import React, { useEffect, useState } from 'react'
import { Form, Message, Image } from 'semantic-ui-react'
import './styles.scss'
import questCompleteIcon from '../../../assets/media/icons/UI-quest-complete-trophy-large.svg'
import importer from '@takedapdt/biolife-core/src/importer'
import PrimaryButton from '../Buttons/PrimaryButton'
import Confetti from 'react-confetti'
import { connect } from 'react-redux'
import { formatPoints } from '../../Helpers/Utils'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '../../NavigationService'

const QuestCompleteComponent = ({ loyaltyGameDataSuccess }) => {
  const { t } = useTranslation('GameComplete')
  const navigate = useNavigate()

  return (
    <div className='gameCompleteBackground'>
      <div className='imageDiv'>
        <Image src={questCompleteIcon} alt='Centered' className='imageIcon' />
        <div className='earnPointstext-overlay'>
          {formatPoints(loyaltyGameDataSuccess?.totalGamePoints)} {t('points')}
        </div>
      </div>
      <h4 className='titleSty'>{t('gameCompleteTitle')}</h4>
      <p className='earnPointsValue'>
        {t('earnpointsTitle').replace('(totalPoints)', formatPoints(loyaltyGameDataSuccess?.totalGamePoints))}
      </p>
      <p className='titleLongText'>
        {t('titleDetails1')}
        <br />
        {t('titleDetails2')}
      </p>
      <p className='rewardTimeTitle'>{t('rewardedPoints')}</p>
      <div className='imageDiv'>
        <PrimaryButton
          text={t('scheduleButton')}
          className='scheduleButtonBackground'
          onClick={() => navigate(ROUTES.AppointmentScheduling)}
        ></PrimaryButton>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  loyaltyGameDataSuccess: state.loyalty?.getLoyaltyGameDataSuccess
})

export default connect(mapStateToProps)(QuestCompleteComponent)
